type VITE_ENVIRONMENT = 'local' | 'development' | 'production';

export type Env = {
  name: VITE_ENVIRONMENT;
  buildNumber: string;
  isLocal: boolean;
  isProductionBuild: boolean;

  apiBaseUrl?: string;
  host: string;
  subdirectory?: string;
  appRoot: string;

  mixPanelToken?: string;
  googleAnalyticsId?: string;
  sentryDSN?: string;
};

const subdirectory = import.meta.env.VITE_SUBDIRECTORY;
const host = `${window.location.protocol}//${window.location.host}`;
const appRoot = `${host}${subdirectory}`;

export const Env: Env = {
  name: import.meta.env.VITE_ENVIRONMENT as VITE_ENVIRONMENT,
  buildNumber: import.meta.env.VITE_BUILD_NUMBER || 'local',
  isLocal: import.meta.env.VITE_ENVIRONMENT === 'local',
  isProductionBuild: import.meta.env.PROD,

  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  host,
  subdirectory,
  appRoot,

  mixPanelToken: import.meta.env.VITE_MIXPANEL_TOKEN,
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
  sentryDSN: import.meta.env.VITE_SENTRY_DSN,
};